var map = {
	"./asclepius.svg": "23ec",
	"./bread.svg": "8426",
	"./chalice-purple.svg": "0f63",
	"./chalice-red.svg": "0713",
	"./chalice-yellow.svg": "c33d",
	"./chicken.svg": "dcc5",
	"./cow.svg": "aabc",
	"./damage-purple.svg": "c2bd",
	"./damage-red.svg": "1d84",
	"./damage-yellow.svg": "8437",
	"./default.svg": "f23d",
	"./discard-hand.svg": "6eed",
	"./dragon.svg": "7d5b",
	"./draw-card.svg": "6bc4",
	"./farmer.svg": "2f68",
	"./forest-fire.svg": "207c",
	"./forest.svg": "71c0",
	"./freeze-blue.svg": "6e85",
	"./freeze-purple.svg": "008b",
	"./goblin.svg": "128e",
	"./grain.svg": "6508",
	"./hatchet-bronze.svg": "0bab",
	"./hatchet-gold.svg": "2216",
	"./hatchet-silver.svg": "de9a",
	"./hatchet-stone.svg": "5390",
	"./hourglass-purple.svg": "2651",
	"./hourglass-red.svg": "7f2f",
	"./hourglass-yellow.svg": "160d",
	"./land-mine.svg": "65e1",
	"./log.svg": "9cb0",
	"./magic-touch.svg": "5a8a",
	"./ore-bronze.svg": "56d2",
	"./ore-gold.svg": "950c",
	"./ore-silver.svg": "a1e3",
	"./pickaxe-bronze.svg": "8e27",
	"./pickaxe-gold.svg": "a164",
	"./pickaxe-silver.svg": "59b6",
	"./pickaxe-stone.svg": "59b5",
	"./pig.svg": "2d1e",
	"./rat.svg": "24a4",
	"./sacrifice-hand.svg": "9cc9",
	"./scythe-bronze.svg": "1be8",
	"./scythe-gold.svg": "feae",
	"./scythe-silver.svg": "370c",
	"./scythe-stone.svg": "3dc5",
	"./shield-cracked.svg": "ce81",
	"./shield-viking.svg": "254a",
	"./skeleton-king.svg": "6b48",
	"./skeleton.svg": "cb5a",
	"./spider-large.svg": "446f",
	"./spider-small.svg": "fa78",
	"./straw.svg": "7e84",
	"./strike-purple.svg": "bcef",
	"./strike-red.svg": "11b3",
	"./strike-yellow.svg": "d167",
	"./sword-bronze.svg": "4d2a",
	"./sword-gold.svg": "0d68",
	"./sword-silver.svg": "9879",
	"./sword.svg": "e7a0",
	"./tree.svg": "6f7d",
	"./troll.svg": "8f9a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6863";